export const VIEW_AUDIT_TRAIL = "VIEW_AUDIT_TRAIL"
export const RESPONSE_AUDIT_TRAIL = "RESPONSE_AUDIT_TRAIL"